import React, { useState, useEffect } from "react";
import {getUserProducts, getLakayUser } from "../auth/apiProduct";
import Slider from '../slider/swiperProduct'
import { isAuthenticated} from "../auth";
import jsSHA from "jssha";


const NewProduct = ({
    laguangeElakay,
    infoSource,
    addressShop,
    userID,
    readUser,
    showB,
    edit = false
}) => {
      const { token } = isAuthenticated();
    const [productsByArrival, setProductsByArrival] = useState([]);
    const [ShopName, setShopName] = useState('seller');

    useEffect(() => {
        if(edit){
            loadProductsByArrivalUser(token)
        }else{
        loadProductsByArrival(userID, 0, 50)
        }
    }, [userID])

    let myStyles = {
        width: "100%",
        backgroundColor: '#f0f0f0'
    }
  
    const loadProductsByArrival = (userID, skip, limit) => {
        userID && getLakayUser(userID, skip, limit, "createdAt").then(data => {
            if(data.error || data.products && data.products.length === 0 ){
                console.log("data not found")
            }else{
            setProductsByArrival(data.products);
            setShopName(data.owner && data.owner.shopName && Array.isArray(data.owner.shopName) ? data.owner.shopName[0]: data.owner && data.owner.shopName? data.owner.shopName : "Lakay");    
            }
        })
    };

const loadProductsByArrivalUser = (token) => {
     const filterUrl =  { search: '' || undefined, category: 'null' }
        getUserProducts(token, 0, 50, {sortBy:'createdAt', asc: 'asc'}, 3,  filterUrl, {"categoriesID.gategoriesLink": [] }).then(data => {
            if (!data) {
                console.log("data Not Found");
            } else {
                setProductsByArrival(data.products);
            }
        });
    }

    return (
<>
        <Slider
            laguangeElakay={laguangeElakay}
            infoSource ={infoSource}
            ProductSwiper={productsByArrival}
            // User={readUser}
            nameSlider={edit ? infoSource.laguangeElakay('headNenu', infoSource.languageAPI).myShop : `Lakay ${ShopName}`}
            linkSlider={edit ? `/myshop`:`/lakay-ShopSeller/${userID}`}
            myStyles={myStyles}
            showB={showB}
            edit ={edit}
        />
</>
    )

};

export default NewProduct;